import { useEffect, useRef } from 'react';

import PubSub from 'pubsub-js';

import { AppEvent } from 'types/AppEvent';

const useSubscription = (event: AppEvent, callback: () => void, deps = []) => {
  const subscriptionsRef = useRef('');

  useEffect(() => {
    subscriptionsRef.current = PubSub.subscribe(event, callback);
    return () => {
      if (subscriptionsRef.current) PubSub.unsubscribe(subscriptionsRef.current);
    };
  }, deps);
  return subscriptionsRef;
};

export default useSubscription;
